// TeamLogo: renders an NBA team logo from the official CDN with abbreviation circle fallback.
// CDN URL: https://cdn.nba.com/logos/nba/{teamId}/primary/L/logo.svg
// Falls back to abbreviation circle when CDN image fails or team name is unrecognized.

import { useState } from 'react';
import { NBA_TEAM_IDS, getTeamAbbr } from '@/lib/nba-teams';

interface TeamLogoProps {
  teamName: string;
  size?: number;
  className?: string;
}

export function TeamLogo({ teamName, size = 48, className = '' }: TeamLogoProps) {
  const [imgError, setImgError] = useState(false);
  const teamId = NBA_TEAM_IDS[teamName];

  if (!teamId || imgError) {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rounded-full bg-secondary flex items-center justify-center font-bold text-sm text-foreground shrink-0 ${className}`}
      >
        {getTeamAbbr(teamName)}
      </div>
    );
  }

  return (
    <img
      src={`https://cdn.nba.com/logos/nba/${teamId}/primary/L/logo.svg`}
      alt={teamName}
      width={size}
      height={size}
      className={`rounded-full shrink-0 object-contain ${className}`}
      onError={() => setImgError(true)}
    />
  );
}

export default TeamLogo;
